import React from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import { getTab } from "../../../utils/tabsUtils";
import financialEducationImg from "../../../../assests/financialEducation/financialEducationMobile.png";

const FinancialEducationCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <WidgetCarouselCard
            image={financialEducationImg}
            imageAlt={texts.financialEducation}
            link={getTab("financialEducation")?.route}
            imageFill
        />
    );
};

export default FinancialEducationCarouselWidget;